/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing($routeProvider: RouteProvider): void {
  $routeProvider
    .when('/api/mobile-seller', {
      templateUrl: require('./mobile-seller/mobile-seller.template.html'),
      title: 'Mobile.de Seller Schnittstelle',
    })
    .when('/api/stellantis-website', {
      templateUrl: require('./stellantis-website/stellantis-website.template.html'),
      title: 'Export zu Stellantis Website',
    })
    .when('/api/schwacke', {
      templateUrl: require('./schwacke/schwacke-api.template.html'),
      title: 'Schwacke Schnittstelle',
    })
    .when('/api/dat', {
      templateUrl: require('./dat/dat-api.template.html'),
      title: 'DAT Schnittstelle',
    })
    .when('/api/juhu-auto', {
      templateUrl: require('./juhu-auto/juhu-auto.template.html'),
      title: 'JuhuAuto Schnittstelle',
    })
    .when('/api/link-entry', {
      templateUrl: require('./link-entry/link-api.template.html'),
      title: 'Link Entry Schnittstelle',
    });
}
